export default class GoogleMapsLocator {
    public map = null;
    public geocoder;

    private defaultLatitude = 43.561486; // Center map
    private defaultLongitude = 12.062988;
    private defaultMarkerIconName = "marker.svg";
    private defaultUserMarkerIconName = "marker-user.svg";
    private mapOptions = {
        center: null,
        zoom: 0,
        minZoom: 7,
        maxZoom: 11,
        defaultZoom: 7,
        locationZoom: 10,
        zoomControl: false,
        panControl: false,
        scrollwheel: false,
        mapTypeControl: false,
        keyboardShortcuts: false,
        streetViewControl: false,
        disableDoubleClickZoom: false,
        options: {
            gestureHandling: 'none'
        }
    };

    private mapStyles = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            saturation: -50
        }]
    }];

    private locatorOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    };

    private userMarker;
    private markerInfoWindow = null;

    public init(zoomOnUserLocation: boolean = true) {
        let self = this;

        this.geocoder = new (<any>window).google.maps.Geocoder();

        this.mapOptions.center = new (<any>window).google.maps.LatLng(this.defaultLatitude, this.defaultLongitude);

        this.map = new (<any>window).google.maps.Map(document.getElementById("GoogleMap"), this.mapOptions);
        this.map.mapTypes.set("styles", new (<any>window).google.maps.StyledMapType(this.mapStyles, { name: "Styles" }));
        this.map.setMapTypeId("styles");

        // Acquiring user location
        navigator.geolocation.getCurrentPosition(function (success) {
            let latLng = new (<any>window).google.maps.LatLng(success.coords.latitude, success.coords.longitude);
            self.setUserMarker(latLng);

            if (zoomOnUserLocation) {
                self.centerMap(latLng);
            }

        }, function (error) {
            let latLng = new (<any>window).google.maps.LatLng(self.defaultLatitude, self.defaultLongitude);
            if (zoomOnUserLocation) {
                self.centerMap(latLng);
            }

        }, this.locatorOptions);
    }

    public onLoad(callback) {
        (<any>window).google.maps.event.addDomListener(this.map, "tilesloaded", callback);
    }

    public centerMap(location) {
        this.map.setCenter(location);
        this.map.setZoom(this.map.locationZoom);
    }

    public fitBounds(bounds) {
        this.map.fitBounds(bounds);
    }

    public centerToUserLocation() {
        if (this.userMarker) {
            this.centerMap(this.userMarker.position);
            this.setUserMarker(this.userMarker.position);
        } else {
            this.centerMap(new (<any>window).google.maps.LatLng(this.defaultLatitude, this.defaultLongitude));
        }
    }

    public centerToDefaultLocation() {
        this.centerMap(new (<any>window).google.maps.LatLng(this.defaultLatitude, this.defaultLongitude));
    }

    public newMarker(latlng, icon, identifier) {
        var marker = new (<any>window).google.maps.Marker({
            identifier: identifier,
            clickable: false,
            position: latlng,
            map: this.map,
            icon: new (<any>window).google.maps.MarkerImage("/images/" + (icon ? icon : this.defaultMarkerIconName), null, null, null, new (<any>window).google.maps.Size(22, 30))
        });

        // (<any>window).google.maps.event.addListener(marker, "click", function () {
        //     if (self.markerInfoWindow) {
        //         self.markerInfoWindow.close();
        //     }
        //     self.markerInfoWindow = new (<any>window).google.maps.InfoWindow();
        //     self.markerInfoWindow.open(self.map, marker);
        // });

        // (<any>window).google.maps.event.addListener(this.map, "click", function () {
        //     if (self.markerInfoWindow) {
        //         self.markerInfoWindow.close();
        //     }
        // });

        return marker;
    }

    public setUserMarker(latlng) {
        let marker = new (<any>window).google.maps.Marker({
            position: latlng,
            map: this.map,
            icon: new (<any>window).google.maps.MarkerImage("/images/" + this.defaultUserMarkerIconName, null, null, null, new (<any>window).google.maps.Size(30, 30))
        });

        if (this.userMarker) {
            this.userMarker.setMap(null);
        }

        this.userMarker = new (<any>window).google.maps.Marker(marker);
    }

    public getUserPosition() {
        if (this.userMarker) {
            return this.userMarker.position;
        }
    }

    public getDistance(p1, p2) {
        let dist = (<any>window).google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
        return parseFloat((dist * 0.001).toFixed(2));
    }

    public openMarkerInfoWindow(marker, contents) {
        if (this.markerInfoWindow) {
            this.markerInfoWindow.close();
            this.markerInfoWindow = null;
        }

        this.markerInfoWindow = new (<any>window).google.maps.InfoWindow();
        this.markerInfoWindow.setContent(contents);
        this.markerInfoWindow.open(this.map, marker);
    }

    public closeMarkerInfoWindow() {
        if (this.markerInfoWindow) {
            this.markerInfoWindow.close();
        }
    }
}